import { useState, useEffect, useContext } from 'react';
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TablePagination,
  Paper,
  Radio,
  FormControl,
} from '@mui/material';
import Select from 'react-select';
import CheckIcon from '@mui/icons-material/Check';
import MRTableSearchToolbar from './MRTableSearchToolbar';
import StoreContext from "../context/StoreContext";
import { escapeRegExp } from '../helpers/SearchToolbar';
import PropTypes from 'prop-types';

const NextApptTable = ({apptData, setSearchedValue, searchedValue, selected, setSelected, setSubService, subService, styledField}) => {
  const [appts, setAppts] = useState(apptData);
  const [visibleAppts, setVisibleAppts] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const { time_zone } = useContext(StoreContext);

  useEffect(() => {
    setAppts(apptData.filter(data => data.services.length > 0))
  }, [apptData, time_zone]);
  
  const requestSearch = (searchValue) => {
    setSearchedValue(searchValue)
  };

  const emptySearch = () => {
    setSearchedValue('')    
  }

  const selectRow = (event, row) => {
    if(selected !== undefined && apptData.indexOf(row) === selected){
      return;
    }
    if(selected === apptData.indexOf(row)){
      setSelected(null)
    } else {
      setSelected(apptData.indexOf(row));
    }
    setSubService(null)
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (index) => selected === index;

  useEffect(() => {

    if(searchedValue !== '') {
      const searchRegex = new RegExp(escapeRegExp(searchedValue), 'i');
      const filteredRows = appts.filter((row) => {
        return searchRegex.test(row.resource) ||
        searchRegex.test(row.time)
      });

      const paginatedRows = filteredRows.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      )

      if(filteredRows.length <= (rowsPerPage*page)) {
        setPage(0)
      }

      setRowsCount(filteredRows.length)
      setVisibleAppts(paginatedRows)

    } else {
      
      const paginatedRows = appts.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      )
      setRowsCount(appts.length)
      setVisibleAppts(paginatedRows)

    }


  }, [appts, page, rowsPerPage, searchedValue])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <MRTableSearchToolbar
          value={searchedValue}
          onChange={search => requestSearch(search.target.value)}
          clearSearch={emptySearch}
          placeholder={'Search time/service type'}
        />
      </Box>
      <TableContainer component={Paper}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Time</TableCell>
              <TableCell>Service type</TableCell>
              <TableCell/>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              visibleAppts.length > 0
              ? 
                visibleAppts?.map((row, index) => {
                  const isItemSelected = isSelected(apptData.indexOf(row));
                  return(
                    <TableRow
                      key={index}
                      onClick={(event) => selectRow(event, row)}
                      selected={isItemSelected}
                      sx={{ cursor: 'pointer' }}
                    >
                      <TableCell sx={{fontWeight: 700}}>
                        <Radio
                          checked={isItemSelected}
                          name="radio-buttons"
                          size='small'
                          color='success'
                          sx={{padding: 0, marginRight: '4px'}}
                        />
                        {row.time}
                      </TableCell>
                      <TableCell>
                        {row.resource}
                        {
                        isItemSelected &&
                        <FormControl fullWidth size='small' sx={{border: styledField(subService), borderRadius: '.25em'}}>
                          <Select
                            isSearchable
                            options={apptData[selected]?.services?.map(s =>{ return { value: s.service_id, label: s.title } } )}
                            onChange={setSubService}
                            value={subService}
                          >
                          </Select>
                        </FormControl>
                        }
                          
                      </TableCell>
                      <TableCell>
                        <CheckIcon color='success' fontSize='small' sx={{visibility: isItemSelected ? 'visible' :'hidden'}}/>
                      </TableCell>
                    </TableRow>
                  )
                })
              : <TableRow sx={{height: 172.4}}>
                  <TableCell colSpan={3} align='center'>
                    No records to display.
                  </TableCell>
                </TableRow>
            }
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5]}
          component="div"
          count={rowsCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
          className='next-appt-table-pagination'
        />
      </TableContainer>
    </>
  )
}

NextApptTable.propTypes = {
  apptData: PropTypes.array, 
  setSearchedValue: PropTypes.func, 
  searchedValue: PropTypes.string,
  selected: PropTypes.any, 
  setSelected: PropTypes.func, 
  setSubService: PropTypes.func
}

export default NextApptTable;